<template>
  <v-menu :nudge-width="100" min-width="350" max-height="600" offset-y>
    <template #activator="{ props }">
      <v-btn icon v-bind="props">
        <v-badge :color="iconColor" :content="pastDeadlinesCount" overlap>
          <v-icon>mdi-alert</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <template #default>
      <v-list dense>
        <DeadlineList :deadlines="filteredDeadlines" :show_account="true" />
      </v-list>
    </template>
  </v-menu>
</template>

<script>
import { computed, onMounted } from "vue";
import DeadlineList from "./DeadlineList.vue";
import { useAuthStoreRefactor } from "../../stores/authStoreRefactor";
import { useDeadlinesStoreRefactor } from "../../stores/deadlinesStoreRefactor";
import moment from "moment";

export default {
  name: "DeadlineMenu",
  components: {
    DeadlineList,
  },
  setup() {
    const authStore = useAuthStoreRefactor();
    const deadlinesStore = useDeadlinesStoreRefactor();

    // Computed
    const currentUser = computed(() => authStore.user);

    const filteredDeadlines = computed(() => {
      if (!currentUser.value) return [];

      return deadlinesStore.openDeadlines
        .filter((d) => d.user_id === currentUser.value.id || d.user_id === null)
        .sort((a, b) => new Date(a.deadline) - new Date(b.deadline));
    });

    const pastDeadlinesCount = computed(() => {
      if (!currentUser.value) return 0;

      const now = moment();
      return deadlinesStore.openDeadlines.filter(
        (d) =>
          (d.user_id === currentUser.value.id || d.user_id === null) &&
          moment(d.deadline).isBefore(now),
      ).length;
    });

    const todayDeadlinesCount = computed(() => {
      if (!currentUser.value) return 0;

      return deadlinesStore.openDeadlines.filter(
        (d) =>
          (d.user_id === currentUser.value.id || d.user_id === null) &&
          moment().isSame(d.deadline, "day"),
      ).length;
    });

    const iconColor = computed(() => {
      if (pastDeadlinesCount.value - todayDeadlinesCount.value > 0) {
        return "red";
      } else if (todayDeadlinesCount.value > 0) {
        return "green";
      }
      return "";
    });

    // Load deadlines on mount
    onMounted(async () => {
      await deadlinesStore.getAll();
    });

    return {
      currentUser,
      filteredDeadlines,
      pastDeadlinesCount,
      todayDeadlinesCount,
      iconColor,
    };
  },
};
</script>
